import { Model, ModelBase } from '@singularsystems/neo-core';
import { Audit } from '@singularsystems/neo-react-services';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import { IAuthorisable } from '../Models/IAuthorisable';
import { IPreAuthorisable } from '../Models/IPreAuthorisable';
import { AxiosPromise } from 'axios';

export interface IAuditApiClient extends Audit.IAuditApiClient {

    preAuthoriseRecord(model: IPreAuthorisable): Promise<void>;

    authoriseRecord(model: IAuthorisable): AxiosPromise<boolean>;

    getChangesSinceLastAuthorised(model: Model.IModelBase): Promise<Array<Model.PlainObject<Audit.AuditEntityLookup>>>;

    // Client only properties / methods
}

@injectable()
export default class AuditApiClient extends Audit.AuditApiClientBase implements IAuditApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/audit`);
    }

    public async preAuthoriseRecord(model: IPreAuthorisable): Promise<void> {
        const info = await this.getModelTypeNameAndKey(model);

        return this.axios.post(`${this.apiPath}/pre-authorise/${encodeURIComponent(info.typeName)}/${info.keyValue}`);
    }

    public async authoriseRecord(model: IAuthorisable): AxiosPromise<boolean> {
        const info = await this.getModelTypeNameAndKey(model);

        return this.axios.post(`${this.apiPath}/authorise/${encodeURIComponent(info.typeName)}/${info.keyValue}`);
    }

    public async getChangesSinceLastAuthorised(model: ModelBase): Promise<Array<Model.PlainObject<Audit.AuditEntityLookup>>> {
        const info = await this.getModelTypeNameAndKey(model);

        return (await this.axios.get(`${this.apiPath}/unauthorised-changes/${encodeURIComponent(info.typeName)}/${info.keyValue}`)).data;
    }

    // Client only properties / methods

    private async getModelTypeNameAndKey(model: Model.IModelBase) {
        const auditType = await this.getAuditType(model.constructor as typeof ModelBase);

        if (auditType) {
            const modelKeys = Object.getOwnPropertyNames(model);
            const normalisedKey = auditType.keyColumn.toUpperCase();
            const key = modelKeys.find(c => c.toUpperCase() === normalisedKey);
    
            // @ts-expect-error
            return { typeName: auditType!.fullName, keyValue: model[key!] };
        } else {
            throw Error(`${model.constructor.name} is not a TemporalEntity.`);
        }
    }
}